module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_aokei-a49cae57a1115090abf0b035d894020b.png";